__turbopack_context__.v({
  "description": "style-module-scss-module__41JRVq__description",
  "hideDefaultCursor": "style-module-scss-module__41JRVq__hideDefaultCursor",
  "media": "style-module-scss-module__41JRVq__media",
  "postCard": "style-module-scss-module__41JRVq__postCard",
  "title": "style-module-scss-module__41JRVq__title",
});
